/**
 * With this component we can handle life-cycle of web-components better.
 */
import PropTypes from 'prop-types';
import { forwardRef, useRef } from 'react';

import { composeRefs } from 'lib/utils';

const ShadowSlot = forwardRef(({ show, children }, ref) => {
  const slotRef = useRef(null);

  if (!show) {
    return null;
  }

  return (
    <>
      <div ref={composeRefs(ref, slotRef)} className="relative z-10" />
      {children({ slotRef })}
    </>
  );
});

ShadowSlot.displayName = 'ShadowSlot';

ShadowSlot.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.func.isRequired,
};

export default ShadowSlot;
